"use strict";

var cx = require("classnames");

var Loader = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    size: React.PropTypes.oneOf(["small","medium","large","extralarge"]),
    speed: React.PropTypes.oneOf(["fast","normal","slow"]),
    color: React.PropTypes.oneOf(["blue","grey"])
  },

  getDefaultProps: function() {
    return {
      size: "medium",
      speed: "normal",
      color: "grey",
      className: ""
    };
  },

  getClassName: function() {
    var className = cx(
      this.props.className,
      "loaderSpeed--" + this.props.speed,
      "loaderSize--" + this.props.size,
      "loaderColor--" + this.props.color,
      "loader");

    return className;
  },

  render: function () {
    return (
      <div className="bootstrap-agendor">
        <div className={this.getClassName()}></div>
      </div>
    );
  }
});

module.exports = Loader;



// WEBPACK FOOTER //
// ./app/shared/components/Loader/loader.jsx